import SearchInspection from "../components/ads/search-inspection";

export default function SearchInspectionHistory() {
  return (
    <>
      <SearchInspection />
    </>
  );
}
